document.addEventListener('DOMContentLoaded', () => {
  // const quickViewBtns = document.querySelectorAll('.quick-view-button');

  // quickViewBtns.forEach((btn) => {
  //   btn.addEventListener('click', () => {
  //     handleProductOptions();
  //     setTimeout(() => {
  //       handleProductOptions();
  //       setupQuickViewContainer();
  //     }, 1000); // Delay for rendering, consider reducing if possible
  //   });
  // });
  function bindQuickViewButtons() {
    const quickViewBtns = document.querySelectorAll('.quick-view-button:not([data-bound])');
  
    quickViewBtns.forEach((btn) => {
      const button = btn.querySelector('button');
      if (button) {
        button.addEventListener('click', () => {
          handleProductOptions();
          setTimeout(() => {
            handleProductOptions();
            setupQuickViewContainer();
          }, 1000);
        });
  
        // Mark as bound to avoid double binding
        btn.setAttribute('data-bound', 'true');
      }
    });
  }
  
  // Initial binding
  bindQuickViewButtons();
  
  // Observe DOM changes to re-bind new quick view buttons
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        bindQuickViewButtons(); // Re-bind when new nodes are added
      }
    }
  });
  
  // Set observer on the parent container of the products
  const gridContainer = document.querySelector('.m-collection-products'); // change selector accordingly
  if (gridContainer) {
    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  function handleProductOptions() {
    const productOptions = document.querySelectorAll('.m-product-option--node');
    const inputVariantId = document.querySelector('.input-variant-id'); // Get the input element to set the variant ID
    
    productOptions.forEach((option) => {
      const checkedInputs = option.querySelectorAll('input[type="radio"]:checked'); // Find checked radio inputs
      checkedInputs.forEach((input) => {
        const parentElement = input.parentElement;
        if (parentElement) {
          parentElement.click(); // Simulate a click on the parent element
          const variantId = parentElement.getAttribute('data-variant-id');
          // Check if variantId is different from the existing value in the input
        if (inputVariantId && inputVariantId.value !== variantId) {
          inputVariantId.value = variantId; // Update the input value with the new variantId
          //console.log("Variant ID set:", variantId); // Log the new variant ID
        }
          let modalParent = document.querySelector(".m-product-quickview");
          const selectedVariant = JSON.parse(modalParent.querySelector("#productVariants[type='application/json']").textContent)?.filter((option) => option?.id == variantId)[0];
          if(!selectedVariant.available) {
            modalParent.querySelector('button[name="add"]')?.setAttribute('disabled', true);
            modalParent.querySelector('button[name="add"] .m-add-to-cart--text').textContent = "SOLD OUT";
          }
          console.warn('dsadaa ', selectedVariant);
          // console.log(parentElement);
        }
      });
    });
  }

  function setupQuickViewContainer() {
    const quickViewContainer = document.querySelector('.custom-quick-view');
    if (!quickViewContainer) {
      console.error('Quick view container not found.');
      return;
    }

    quickViewContainer.addEventListener('click', (event) => {
      const clickedNode = event.target.closest('.m-product-option--node');
      if (clickedNode) {
        let variantId = clickedNode.getAttribute('data-variant-id');
        /* New added code*/
        const checkedInputs = quickViewContainer.querySelectorAll('input[type="radio"]:checked');
        var selected_options = []
        checkedInputs.forEach(selectedOption => {
          selected_options.push(selectedOption.value);
        })
        console.warn(selected_options);
        if(selected_options.length > 1) {
          const joinedOptions = selected_options?.join(' / ');
          const filteredArray = JSON.parse(document.querySelector(".m-product-quickview #productVariants[type='application/json']").textContent).filter((option) => option?.title == joinedOptions)[0];
          console.warn(filteredArray);
          variantId = filteredArray?.id;
        }
        /* END */
        const variantInput = document.querySelector('.input-variant-id');

        if (variantInput) {
          variantInput.value = variantId; // Update the value directly
        } else {
          console.error('Input variant ID element not found.');
        }
        // Re-evaluate the notify-redirect state after the size changes.
        setTimeout(() => applyQvNotifyRedirect(quickViewContainer), 50);
      }
    });

    setupQvNotifyRedirect(quickViewContainer);
  }

  // xflow's variant-aware Notify Me only mounts on the full product page, not the
  // quick-view popup. So when a sold-out variant is selected in the popup, turn the ATC
  // into a "Notify Me" that sends the shopper to the product page (with the sold-out
  // variant pre-selected) where xflow's Notify Me shows automatically.
  function getQvProductUrl(container) {
    try {
      const pd =
        container.querySelector("#productData[type='application/json']") ||
        document.querySelector('.m-product-quickview #productData');
      const data = pd ? JSON.parse(pd.textContent) : null;
      if (data && data.url) return data.url;
      if (data && data.handle) {
        const base = (window.MinimogSettings && window.MinimogSettings.base_url) || '/';
        return `${base}products/${data.handle}`;
      }
    } catch (e) {}
    return null;
  }

  function getQvSelectedVariant(container) {
    try {
      const node = container.querySelector("#productVariants[type='application/json']");
      if (!node) return null;
      const variants = JSON.parse(node.textContent);
      const input = container.querySelector('.input-variant-id');
      let id = input && input.value ? Number(input.value) : null;
      if (!id) {
        const checked = [...container.querySelectorAll('.m-product-option--node input[type="radio"]:checked')].map((i) => i.value);
        const title = checked.join(' / ');
        const match = variants.find((v) => v.title === title);
        id = match ? match.id : null;
      }
      return variants.find((v) => v.id === id) || null;
    } catch (e) {
      return null;
    }
  }

  function applyQvNotifyRedirect(container) {
    const btn = container.querySelector('[name="add"]');
    if (!btn) return;
    const textEl = btn.querySelector('.m-add-to-cart--text');
    const variant = getQvSelectedVariant(container);
    const soldOut = !!(variant && variant.available === false);

    // Only mutate when something actually changes — setting identical values still
    // fires the button's MutationObserver and would loop.
    if (soldOut) {
      if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      if (btn.classList.contains('disabled')) btn.classList.remove('disabled');
      if (!btn.classList.contains('qv-notify-redirect')) btn.classList.add('qv-notify-redirect');
      if (textEl && textEl.textContent !== 'NOTIFY ME WHEN AVAILABLE') {
        textEl.textContent = 'NOTIFY ME WHEN AVAILABLE';
      }
      container.__qvNotifyVariantId = variant.id;
    } else {
      if (btn.classList.contains('qv-notify-redirect')) btn.classList.remove('qv-notify-redirect');
      container.__qvNotifyVariantId = null;
    }
  }

  function setupQvNotifyRedirect(container) {
    if (container.__qvNotifyBound) return;
    container.__qvNotifyBound = true;
    const btn = container.querySelector('[name="add"]');
    if (!btn) return;

    // Intercept clicks while in notify state and redirect to the product page.
    btn.addEventListener(
      'click',
      (event) => {
        if (!btn.classList.contains('qv-notify-redirect')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const url = getQvProductUrl(container);
        const id = container.__qvNotifyVariantId;
        if (url) {
          window.location.href = id ? `${url}${url.includes('?') ? '&' : '?'}variant=${id}` : url;
        }
      },
      true
    );

    // The quick-view's variant-picker re-disables the button on variant change, so
    // re-apply the notify state when its disabled/class attributes change. Attributes
    // only — never childList/subtree — to stay cheap and avoid feedback loops.
    const observer = new MutationObserver(() => applyQvNotifyRedirect(container));
    observer.observe(btn, { attributes: true, attributeFilter: ['disabled', 'class'] });

    applyQvNotifyRedirect(container);
  }

  // The quick-view modal is opened by product-quick-view.js. Rather than observe the whole
  // document (which fires for every node the quick-view injects and freezes the page), wire
  // the notify-redirect only when a quick-view trigger is clicked, then poll briefly for the
  // injected .custom-quick-view container.
  document.addEventListener(
    'click',
    (event) => {
      if (!event.target.closest('.m-product-quickview-button, .quick-view-button')) return;
      let tries = 0;
      const timer = setInterval(() => {
        const container = document.querySelector('.custom-quick-view');
        if (container && !container.__qvNotifyBound) {
          clearInterval(timer);
          setupQvNotifyRedirect(container);
        } else if (++tries > 50) {
          clearInterval(timer);
        }
      }, 100);
    },
    true
  );
});
